import React from "react";
import { SITE_CONTENT } from "../content";

const AboutSection = () => {
  const { aboutSection } = SITE_CONTENT.pages.homePage;
  const logoImage = SITE_CONTENT.global.logoImage;

  // Parse heading
  const headingLines = aboutSection.heading.split("\n");

  return (
    <section
      id="about"
      style={{
        background: "#fff8d6",
        padding: "88px 5vw",
      }}
    >
      {/* Section heading */}
      <div style={{ textAlign: "center", marginBottom: "52px" }}>
        <span
          style={{
            display: "block",
            fontFamily: "Raleway, sans-serif",
            fontSize: "10px",
            fontWeight: 700,
            letterSpacing: "4px",
            textTransform: "uppercase",
            color: "#d4a900",
            marginBottom: "10px",
          }}
        >
          {aboutSection.eyebrow}
        </span>
        <h2
          style={{
            fontFamily: "Raleway, sans-serif",
            fontSize: "clamp(2rem, 5vw, 3rem)",
            fontWeight: 800,
            color: "var(--rest-dark)",
            textTransform: "uppercase",
            letterSpacing: "1px",
            lineHeight: 1.05,
          }}
        >
          {aboutSection.title}
        </h2>
      </div>

      {/* Two-column grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "60px",
          alignItems: "start",
          maxWidth: "1100px",
          margin: "0 auto",
        }}
      >
        {/* LEFT — text content */}
        <div>
          {/* Multi-line heading with yellow highlight on line 2 */}
          <h3
            style={{
              fontFamily: "Raleway, sans-serif",
              fontSize: "clamp(1.6rem, 3vw, 2.4rem)",
              fontWeight: 800,
              color: "var(--rest-dark)",
              lineHeight: 1.15,
              textTransform: "uppercase",
              letterSpacing: "0.3px",
              marginBottom: "1.4rem",
            }}
          >
            {headingLines.map((line, i) => (
              <span
                key={i}
                style={{
                  display: "block",
                  color: i === 1 ? "#d4a900" : "var(--rest-dark)",
                }}
              >
                {line}
              </span>
            ))}
          </h3>

          {/* Paragraphs */}
          {aboutSection.paragraphs.map((p, idx) => (
            <p
              key={idx}
              style={{
                fontSize: "14px",
                color: "var(--rest-mid)",
                lineHeight: 1.75,
                marginBottom: "1rem",
              }}
            >
              {p}
            </p>
          ))}

          {/* Bullet list */}
          <ul
            style={{
              listStyle: "none",
              marginTop: "1rem",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {aboutSection.highlights.map((item, idx) => (
              <li
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  fontSize: "13px",
                  color: "var(--rest-dark)",
                  lineHeight: 1.5,
                }}
              >
                <span
                  style={{
                    color: "#d4a900",
                    fontSize: "14px",
                    marginTop: "1px",
                    flexShrink: 0,
                    fontWeight: 700,
                  }}
                >
                  ▶
                </span>
                {item}
              </li>
            ))}
          </ul>

          {/* Branches Section */}
          <div
            style={{
              marginTop: "2rem",
              background: "#0d0d0d",
              borderRadius: "6px",
              padding: "20px 24px",
              border: "2px solid #f5c518",
            }}
          >
            <h4
              style={{
                fontFamily: "Raleway, sans-serif",
                fontSize: "11px",
                fontWeight: 700,
                letterSpacing: "3px",
                textTransform: "uppercase",
                color: "#f5c518",
                marginBottom: "14px",
              }}
            >
              📍 Our Branches
            </h4>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {aboutSection.branches.map((branch, idx) => (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "8px 0",
                    borderBottom: idx < aboutSection.branches.length - 1 ? "1px solid rgba(255,255,255,0.1)" : "none",
                  }}
                >
                  <div>
                    <span
                      style={{
                        fontFamily: "Raleway, sans-serif",
                        fontWeight: 700,
                        fontSize: "14px",
                        color: "#fff",
                      }}
                    >
                      {branch.city}
                    </span>
                    <span
                      style={{
                        display: "block",
                        fontSize: "11px",
                        color: "rgba(255,255,255,0.55)",
                        marginTop: "2px",
                      }}
                    >
                      {branch.detail}
                    </span>
                  </div>
                  <span
                    style={{
                      fontSize: "10px",
                      fontWeight: 700,
                      letterSpacing: "1.5px",
                      textTransform: "uppercase",
                      padding: "4px 10px",
                      borderRadius: "3px",
                      background: branch.status === "open" ? "#f5c518" : "rgba(255,255,255,0.1)",
                      color: branch.status === "open" ? "#1a1a1a" : "rgba(255,255,255,0.5)",
                    }}
                  >
                    {branch.status === "open" ? "Open Now" : "Coming Soon"}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT — dark visual card */}
        <div
          style={{
            background: "#0d0d0d",
            borderRadius: "6px",
            padding: "44px 36px",
            textAlign: "center",
            border: "3px solid #f5c518",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
            position: "sticky",
            top: "120px",
          }}
        >
          {/* Logo */}
          <img
            src={logoImage}
            alt="Combo Box"
            style={{ width: "200px", maxWidth: "80%", marginBottom: "4px" }}
          />

          {/* Halal Banner */}
          <div
            style={{
              background: "#006400",
              color: "#fff",
              borderRadius: "4px",
              padding: "10px 20px",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <svg viewBox="0 0 100 100" width="22" height="22" fill="currentColor">
              <circle cx="50" cy="50" r="45" fill="none" stroke="currentColor" strokeWidth="5"/>
              <circle cx="50" cy="50" r="38" fill="none" stroke="currentColor" strokeWidth="2"/>
              <text x="50" y="55" fontSize="26" fontWeight="bold" textAnchor="middle" fill="currentColor">حلال</text>
              <text x="50" y="75" fontSize="12" fontWeight="bold" textAnchor="middle" fill="currentColor">HALAL</text>
            </svg>
            <span
              style={{
                fontFamily: "Raleway, sans-serif",
                fontSize: "13px",
                fontWeight: 700,
                letterSpacing: "2px",
                textTransform: "uppercase",
              }}
            >
              100% Halal Certified
            </span>
          </div>

          {/* Tagline */}
          <p
            style={{
              fontFamily: "Raleway, sans-serif",
              fontStyle: "italic",
              fontSize: "20px",
              fontWeight: 700,
              color: "#ffffff",
              lineHeight: 1.5,
              whiteSpace: "pre-line",
            }}
          >
            {aboutSection.visualTagline}
          </p>

          {/* Brand tag button */}
          <span
            style={{
              display: "inline-block",
              background: "#f5c518",
              color: "#1a1a1a",
              fontFamily: "Raleway, sans-serif",
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: "2px",
              textTransform: "uppercase",
              padding: "10px 24px",
              borderRadius: "3px",
              marginTop: "4px",
            }}
          >
            {aboutSection.visualTag}
          </span>

          <p style={{ fontSize: "12px", color: "rgba(255,255,255,0.5)", marginTop: "4px" }}>
            combobox.in
          </p>
        </div>
      </div>

      {/* Responsive styles */}
      <style>{`
        @media (max-width: 900px) {
          #about > div:last-child {
            grid-template-columns: 1fr !important;
          }
          #about > div:last-child > div:last-child {
            position: static !important;
          }
        }
      `}</style>
    </section>
  );
};

export default AboutSection;
